import { ComponentType } from '@angular/cdk/portal';
import { Component, inject } from '@angular/core';
import { PayeeCasesService } from 'src/app/shared/payee-cases/payee-cases.service';
import { BulkUploadFilterComponent } from './bulk-upload-filter/bulk-upload-filter.component';
import { DeletedCasesFilterComponent } from './deleted-cases-filter/deleted-cases-filter.component';
import { LawFirmFilterComponent } from './law-firm-filter/law-firm-filter.component';
import { MissingLawFirmsFilterComponent } from './missing-law-firms-filter/missing-law-firms-filter.component';
import { MissingRefundFilterComponent } from './missing-refund-filter/missing-refund-filter.component';
import { ChipDropdownComponent } from '../../../../shared/payee-cases/chip-dropdown/chip-dropdown.component';
import { MatIcon } from '@angular/material/icon';
import { NgComponentOutlet } from '@angular/common';

type Filter = {
  component: ComponentType<unknown>;
  name: string;
};

@Component({
  selector: 'app-more-filters',
  templateUrl: './more-filters.html',
  styleUrls: ['./more-filters.scss'],
  imports: [ChipDropdownComponent, MatIcon, NgComponentOutlet],
})
export class MoreFilters {
  private payeeCasesService = inject(PayeeCasesService);

  private readonly filterSubjects = [
    this.payeeCasesService.law_firm_missing,
    this.payeeCasesService.law_firm_name,
    this.payeeCasesService.bulk_upload_name,
    this.payeeCasesService.show_deleted,
    this.payeeCasesService.refund_missing,
  ];

  readonly filters: Filter[] = [
    { component: DeletedCasesFilterComponent, name: 'Törölt ügyek mutatása' },
    { component: MissingLawFirmsFilterComponent, name: 'Ügyvéd léte' },
    { component: LawFirmFilterComponent, name: 'Ügyvéd neve' },
    { component: BulkUploadFilterComponent, name: 'Tömeges feltöltés' },
    { component: MissingRefundFilterComponent, name: 'Hiányzó visszatérítés' },
  ];

  dropdownOpen = false;
  activeFilter: Filter | null = null;

  get hasActiveFilters(): boolean {
    return this.filterSubjects.some((s) => s.value !== null);
  }

  displayWith = (): string => 'Aktív szűrők';

  openFilter(filter: Filter): void {
    this.activeFilter = filter;
  }

  closeFilter(): void {
    this.activeFilter = null;
  }

  clearAllFilters(): void {
    for (const s of this.filterSubjects) {
      s.next(null);
    }
  }
}
